export default "__VITE_ASSET__BgyoN9$w__"